// 监控 API 由 web-sdk/server 提供，经 vite 代理到 localhost:3001
const API_BASE = import.meta.env.VITE_API_BASE || "";
export async function fetchStats() {
    const res = await fetch(`${API_BASE}/api/stats`);
    return res.json();
}
export async function fetchReports(query) {
    const params = new URLSearchParams();
    if (query.type)
        params.set("type", query.type);
    if (query.keyword)
        params.set("keyword", query.keyword);
    params.set("page", String(query.page || 1));
    params.set("pageSize", String(query.pageSize || 20));
    const res = await fetch(`${API_BASE}/api/reports?${params}`);
    return res.json();
}
export async function clearReports() {
    await fetch(`${API_BASE}/api/reports`, { method: "DELETE" });
}
export async function resolveStack(stack, release) {
    const res = await fetch(`${API_BASE}/api/resolve-stack`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stack, release }),
    });
    return res.json();
}
